import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export class PartnerSlider {
  constructor() {
    this.initSlider()
  }

  initSlider() {
    new Swiper('.partners__slider', {
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      speed: 1000,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        767: {
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 113,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
}
